import DownloadIcon from "assets/Chart/DownloadIconDefault.svg";
import DeleteIcon from "assets/Other/delete.svg";
import EditIcon from "assets/Other/edit_icon.svg";

import { FORMATTED_WIDGET_TYPE } from "./constantStrings";
// Need correct Icons for Move UP/DOWN
// import MoveUpIcon from 'assets/Other/arrow-ios-up.svg';
// import MoveDownIcon from 'assets/Other/arrow-ios-down.svg';

export const DashboardWidgetsMenuItems = [
  { id: "EDIT_WIDGET", label: "Edit Widget", icon: EditIcon },
  { id: "DELETE_WIDGET", label: "Delete Widget", icon: DeleteIcon }
  // { id: 'DOWNLOAD_WIDGET', label: 'Download', icon: DownloadIcon }
];

export const ReportWidgetsMenuItems = [
  { id: "EDIT_WIDGET", label: "Edit Widget", icon: EditIcon },
  { id: "DELETE_WIDGET", label: "Delete Widget", icon: DeleteIcon }
  // { id: 'MOVE_WIDGET_UP', label: 'Move Up', icon: MoveUpIcon },
  // { id: 'MOVE_WIDGET_DOWN', label: 'Move Down', icon: MoveDownIcon }
];

export const getReportWidgetsMenuItems = widgetType => {
  if (widgetType === FORMATTED_WIDGET_TYPE.Text || widgetType === FORMATTED_WIDGET_TYPE.Tag || widgetType === FORMATTED_WIDGET_TYPE.Gauge) {
    return ReportWidgetsMenuItems;
  } else {
    const obj = { id: "DOWNLOAD_WIDGET_CSV", label: "Download Excel File", icon: DownloadIcon };
    return [...ReportWidgetsMenuItems, obj];
  }
};
